/* ── Cart mutation interceptor (works with ReCharge / any third-party cart) ── */
(function () {
  var CART_MUTATE = /\/cart\/(add|change|update|clear)\.js/;
  var _fetch = window.fetch;

  function broadcastCartChange() {
    _fetch.call(window, Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:external-change', {
          bubbles: true,
          detail: { cart: cart }
        }));
      });
  }

  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = CART_MUTATE.test(url);
    var result = _fetch.apply(this, arguments);
    if (isCartMutation) {
      result.then(function () {
        setTimeout(broadcastCartChange, 300);
      });
    }
    return result;
  };

  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartMutation = CART_MUTATE.test(url);
    return _xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartMutation) {
      this.addEventListener('load', function () {
        setTimeout(broadcastCartChange, 300);
      });
    }
    return _xhrSend.apply(this, arguments);
  };
})();

document.addEventListener('click', function (e) {

  const card = e.target.closest('product-card');
  if (!card) return;

  // Make sure it's inside <product-list>
  if (!card.closest('product-list')) return;

  // Ignore interactive elements
  if (
    e.target.closest('button') ||
    e.target.closest('form') ||
    e.target.closest('input') ||
    e.target.closest('select') ||
    e.target.closest('textarea') ||
    e.target.closest('a')
  ) {
    return;
  }

  const link = card.querySelector('.product-card__title a[href]');
  if (!link) return;

   window.location.href = link.href;

});

function ruggedDogProductFormSellingPlanId(form) {
  if (!form) return '';
  var checkedRadio = form.querySelector('input[type="radio"][name="selling_plan"]:checked');
  if (checkedRadio) return String(checkedRadio.value || '').trim();
  var sel = form.querySelector('select[name="selling_plan"]');
  if (sel) return String(sel.value || '').trim();
  var hidden = form.querySelector('input[type="hidden"][name="selling_plan"]');
  if (hidden) return String(hidden.value || '').trim();
  return '';
}

/* ── Dynamic ATC price (variant + subscription + qty + addons) ── */
(function () {
  if (!document.querySelector('[data-atc-price]')) return;

  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getMainProductForm() {
    var el = document.querySelector('[data-atc-price]');
    return el ? el.closest('form') : document.querySelector('form[is="product-form"]');
  }

  function syncVariantPricingToDom(form, variant) {
    if (!form || !variant) return;
    var priceEl = form.querySelector('[data-atc-price]');
    if (!priceEl) return;

    var cents = typeof variant.price === 'number' ? variant.price : parseInt(variant.price, 10) || 0;
    var cmpRaw = variant.compare_at_price != null ? variant.compare_at_price : variant.compareAtPrice;
    var cmp = typeof cmpRaw === 'number' ? cmpRaw : parseInt(cmpRaw, 10);
    if (isNaN(cmp) || cmp <= cents) cmp = null;

    function applyVariantPricingAttrs(el) {
      el.setAttribute('data-unit-price', String(cents));
      el.setAttribute('data-unit-retail-cents', String(cents));
      if (cmp) el.setAttribute('data-unit-compare-cents', String(cmp));
      else el.removeAttribute('data-unit-compare-cents');
    }
    applyVariantPricingAttrs(priceEl);
    document.querySelectorAll('[data-atc-price]').forEach(function (ext) {
      if (ext !== priceEl) applyVariantPricingAttrs(ext);
    });
  }

  function getVariantsData(form) {
    var script = form && form.querySelector('script[data-selling-prices]');
    if (!script) return null;
    try { return JSON.parse(script.textContent.replace(/;\s*$/, '')); } catch (e) { return null; }
  }

  function getSellingPlanPrice(form, planId) {
    if (!planId) return undefined;
    var variants = getVariantsData(form);
    if (!variants) return undefined;
    var variantId = form.querySelector('input[name="id"]');
    var vid = variantId ? String(variantId.value) : '';
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === vid && variants[i].selling_plan_allocations) {
        for (var j = 0; j < variants[i].selling_plan_allocations.length; j++) {
          var alloc = variants[i].selling_plan_allocations[j];
          if (String(alloc.selling_plan_id) === planId) return alloc.price;
        }
      }
    }
    return undefined;
  }

  function getUnitPrice(form) {
    if (!form) return 0;
    var planId = ruggedDogProductFormSellingPlanId(form);
    if (planId) {
      var p = getSellingPlanPrice(form, planId);
      if (p !== undefined) return p;
    }
    var el = form.querySelector('[data-atc-price]');
    return el ? parseInt(el.getAttribute('data-unit-price'), 10) || 0 : 0;
  }

  function getQty(form) {
    var input =
      (form && form.querySelector('input[name="quantity"]')) ||
      document.querySelector('.product-info__inline-qty input[name="quantity"]');
    if (!input && form && form.id) {
      input = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    }
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function getAddonsTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      total += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
    });
    return total;
  }

  function getAddonsCompareTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      var sale = parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
      var cmpAttr = cb.getAttribute('data-addon-compare-price');
      var cmp = cmpAttr != null && cmpAttr !== '' ? parseInt(cmpAttr, 10) : NaN;
      if (!isNaN(cmp) && cmp > sale) total += cmp;
      else total += sale;
    });
    return total;
  }

  /** Per-unit strikethrough “was” price for the main line (compare_at if on sale, else retail). */
  function getMainStrikeUnitCents(form) {
    var el = form && form.querySelector('[data-atc-price]');
    if (!el) return 0;
    var retail = parseInt(el.getAttribute('data-unit-retail-cents'), 10);
    if (isNaN(retail)) retail = parseInt(el.getAttribute('data-unit-price'), 10) || 0;
    var cmpAttr = el.getAttribute('data-unit-compare-cents');
    var cmp = cmpAttr != null && cmpAttr !== '' ? parseInt(cmpAttr, 10) : NaN;
    if (!isNaN(cmp) && cmp > retail) return cmp;
    return retail;
  }

  function updateAtcPriceRoot(root, saleTotalCents, compareTotalCents) {
    var saleEl = root.querySelector('[data-atc-price-sale]');
    var compareEl = root.querySelector('[data-atc-price-compare]');
    var saleStr = fmt.format(saleTotalCents / 100);
    if (!saleEl) {
      root.textContent = saleStr;
      return;
    }
    saleEl.textContent = saleStr;
    if (compareEl) {
      if (compareTotalCents > saleTotalCents) {
        compareEl.textContent = fmt.format(compareTotalCents / 100);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  }

  function updateATCPrice(form) {
    form = form || getMainProductForm();
    if (!form) return;
    var root = form.querySelector('[data-atc-price]');
    if (!root) return;
    var qty = getQty(form);
    var mainSaleTotal = getUnitPrice(form) * qty;
    var mainCompareTotal = getMainStrikeUnitCents(form) * qty;
    var saleTotal = mainSaleTotal + getAddonsTotal();
    var compareTotal = mainCompareTotal + getAddonsCompareTotal();
    updateAtcPriceRoot(root, saleTotal, compareTotal);
    document.querySelectorAll('[data-atc-price]').forEach(function (ext) {
      if (ext !== root) updateAtcPriceRoot(ext, saleTotal, compareTotal);
    });
  }

  var productForm = getMainProductForm();
  updateATCPrice(productForm);

  function formForAtcTarget(el) {
    if (!el) return getMainProductForm();
    var f = el.form || (el.closest && el.closest('form'));
    if (f && f.querySelector('[data-atc-price]')) return f;
    return getMainProductForm();
  }

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="quantity"]') ||
      e.target.matches('.product-addons__checkbox') ||
      e.target.matches('input[name="selling_plan"]') ||
      e.target.matches('select[name="selling_plan"]')
    ) {
      updateATCPrice(formForAtcTarget(e.target));
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateATCPrice(formForAtcTarget(e.target));
    }
  });

  var spObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t.name === 'selling_plan' || t.name === 'properties[__foxsell:dynamic_add_on_bundle_id]' || (t.nodeType === 1 && t.querySelector && t.querySelector('[name="selling_plan"]'))) {
        updateATCPrice(getMainProductForm());
        return;
      }
    }
  });

  if (productForm) {
    spObserver.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  }

  document.addEventListener('variant:change', function (e) {
    var mapEl = document.querySelector('[data-bogo-texts]');
    if (mapEl && e.detail && e.detail.variant) {
      try {
        var map = JSON.parse(mapEl.textContent);
        var text = map[String(e.detail.variant.id)] || '';
        document.querySelectorAll('[data-bogo-badge]').forEach(function (badge) {
          badge.textContent = text;
          badge.hidden = !text;
        });
      } catch (err) {}
    }

    var form = e.target && e.target.closest ? e.target.closest('form') : getMainProductForm();
    if (!form || !e.detail || !e.detail.variant) {
      requestAnimationFrame(function () { updateATCPrice(getMainProductForm()); });
      return;
    }
    syncVariantPricingToDom(form, e.detail.variant);
    requestAnimationFrame(function () { updateATCPrice(form); });
  });
})();

/* ── Product Addons ── */
(function () {
  var container = document.querySelector('[data-product-addons]');
  if (!container) return;

  var formId = container.getAttribute('data-form-id');
  var form = document.getElementById(formId);
  if (!form) return;

  /* ── Add-to-cart interception (capture phase to fire before theme/Rebuy) ── */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;

    var checkedBoxes = container.querySelectorAll('.product-addons__checkbox:checked');
    if (!checkedBoxes.length) return;

    e.preventDefault();
    e.stopPropagation();

    var mainVariantInput = form.querySelector('input[name="id"]');
    if (!mainVariantInput) return;

    var mainId = mainVariantInput.value;
    var quantityInput = form.querySelector('input[name="quantity"]');
    var mainQty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    function formLineProperties(formEl) {
      var props = {};
      if (!formEl || !formEl.querySelectorAll) return props;
      formEl.querySelectorAll('[name^="properties["]').forEach(function (input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (!input.checked) return;
        }
        var m = input.name && input.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        var raw = input.value != null ? String(input.value).trim() : '';
        if (!raw && input.type !== 'checkbox') return;
        props[m[1]] = raw;
      });
      return props;
    }

    function addonRowTitle(cb) {
      var row = cb.closest('.product-addons__item');
      if (!row) return '';
      var nameEl = row.querySelector('.product-addons__name');
      return nameEl ? nameEl.textContent.trim() : '';
    }

    var addonTitles = [];
    var addonVariantIds = [];
    checkedBoxes.forEach(function (cb) {
      addonVariantIds.push(String(cb.value));
      var t = addonRowTitle(cb);
      if (t) addonTitles.push(t);
    });

    var addonListNote = addonTitles.length
      ? addonTitles.join(', ').slice(0, 240)
      : addonVariantIds.join(',').slice(0, 240);

    var mainItem = {
      id: parseInt(mainId, 10),
      quantity: mainQty,
      properties: Object.assign({}, formLineProperties(form), {
        '_Includes add-ons': addonListNote,
        '_Add-on variant IDs': addonVariantIds.join(',')
      })
    };

    var spVal = ruggedDogProductFormSellingPlanId(form);
    if (spVal) {
      var spNum = parseInt(String(spVal).replace(/\D/g, ''), 10);
      if (!isNaN(spNum)) mainItem.selling_plan = spNum;
    }

    var items = [mainItem];
    checkedBoxes.forEach(function (cb) {
      var aid = parseInt(cb.value, 10);
      var rowTitle = addonRowTitle(cb);
      var addOnProps = {
        '_Product add-on': 'Yes',
        '_Bundled with parent variant': String(mainId)
      };
      if (rowTitle) addOnProps['_Add-on title'] = rowTitle.slice(0, 120);
      items.push({
        id: aid,
        quantity: 1,
        properties: addOnProps
      });
    });

    var submitButtons = Array.from(form.elements).filter(function (el) {
      return el.type === 'submit';
    });
    submitButtons.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: Shopify.routes.root + 'variants/' + mainId
      })
    })
      .then(function (response) {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        return response.json().then(function (json) {
          return { ok: response.ok, data: json };
        });
      })
      .then(function (result) {
        if (result.ok) {
          document.documentElement.dispatchEvent(
            new CustomEvent('product-addons:cart-add', {
              bubbles: true,
              detail: {
                parentVariantId: parseInt(mainId, 10),
                mainQuantity: mainQty,
                addonVariantIds: addonVariantIds.map(function (id) { return parseInt(id, 10); }),
                addonTitles: addonTitles.slice()
              }
            })
          );
          if (
            window.themeVariables.settings.cartType === 'page' ||
            window.themeVariables.settings.pageType === 'cart'
          ) {
            window.location.href = Shopify.routes.root + 'cart';
            return;
          }
          return fetch(Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              cartContent.sections = result.data.sections;

              form.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: result.data.items || [result.data],
                  cart: cartContent
                }
              }));

              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cartContent }
              }));
            });
        } else {
          form.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: result.data.description }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function () {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
      });
  }, true);
})();

/* ── Product Addon Popup ── */
(function () {
  var overlay = document.querySelector('[data-addon-popup-overlay]');
  if (!overlay) return;

  var popup = overlay.querySelector('[data-addon-popup]');
  var imgWrap = overlay.querySelector('[data-addon-popup-img-wrap]');
  var imgEl = overlay.querySelector('[data-addon-popup-img]');
  var titleEl = overlay.querySelector('[data-addon-popup-title-el]');
  var priceEl = overlay.querySelector('[data-addon-popup-price-el]');
  var descEl = overlay.querySelector('[data-addon-popup-desc-el]');
  var urlEl = overlay.querySelector('[data-addon-popup-url-el]');
  var mainEl = document.getElementById('main');

  function open(btn) {
    var title = btn.getAttribute('data-addon-popup-title') || '';
    var desc = btn.getAttribute('data-addon-popup-desc') || '';
    var image = btn.getAttribute('data-addon-popup-image') || '';
    var price = btn.getAttribute('data-addon-popup-price') || '';
    var comparePrice = btn.getAttribute('data-addon-popup-compare-price') || '';
    var url = btn.getAttribute('data-addon-popup-url') || '';

    titleEl.textContent = title;
    if (comparePrice) {
      priceEl.innerHTML = '<span class="product-addons__price--sale">' + price + '</span> <span class="product-addons__price--compare">' + comparePrice + '</span>';
    } else {
      priceEl.textContent = price;
    }
    descEl.innerHTML = desc;

    if (url && urlEl) {
      urlEl.href = url;
      urlEl.hidden = false;
    } else if (urlEl) {
      urlEl.hidden = true;
    }

    if (image) {
      imgEl.src = image;
      imgEl.alt = title;
      imgEl.style.display = '';
    } else {
      imgEl.style.display = 'none';
    }

    overlay.hidden = false;
    if (mainEl) { mainEl.style.position = 'relative'; mainEl.style.zIndex = '10'; }
    requestAnimationFrame(function () {
      overlay.classList.add('is-active');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-active');
    overlay.addEventListener('transitionend', function handler() {
      overlay.removeEventListener('transitionend', handler);
      overlay.hidden = true;
      if (mainEl) { mainEl.style.position = ''; mainEl.style.zIndex = ''; }
    });
    document.body.style.overflow = '';
  }

  document.querySelector('[data-product-addons]').addEventListener('click', function (e) {
    var btn = e.target.closest('.product-addons__info-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  });

  overlay.querySelector('[data-addon-popup-close]').addEventListener('click', close);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });
})();

/* ── Standalone Free Shipping Bar ── */
(function () {
  var bar = document.querySelector('[data-standalone-shipping-bar]');
  if (!bar) return;

  var hasFreeShippingTag = bar.hasAttribute('data-free-shipping');
  var threshold = parseInt(bar.getAttribute('data-shipping-threshold'), 10) || 0;
  var msgTemplate = bar.getAttribute('data-shipping-message') || '';
  var successMsg = bar.getAttribute('data-shipping-success') || '';
  var hintMsg = bar.getAttribute('data-shipping-hint') || '';
  var fillEl = bar.querySelector('[data-standalone-shipping-fill]');
  var textEl = bar.querySelector('[data-standalone-shipping-text]');
  var hintEl = bar.querySelector('[data-standalone-shipping-hint]');
  var cartTotal = 0;

  if (!threshold && !hasFreeShippingTag) return;

  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getProductFormForBar() {
    var atc = document.querySelector('[data-atc-price]');
    return atc ? atc.closest('form') : document.querySelector('form[is="product-form"]');
  }

  function getBarSellingPlanPrice(form, planId) {
    if (!planId || !form) return undefined;
    var script = form.querySelector('script[data-selling-prices]');
    if (!script) return undefined;
    try {
      var variants = JSON.parse(script.textContent.replace(/;\s*$/, ''));
      var variantInput = form.querySelector('input[name="id"]');
      var vid = variantInput ? String(variantInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === vid && variants[i].selling_plan_allocations) {
          for (var j = 0; j < variants[i].selling_plan_allocations.length; j++) {
            var alloc = variants[i].selling_plan_allocations[j];
            if (String(alloc.selling_plan_id) === planId) return alloc.price;
          }
        }
      }
    } catch (e) {}
    return undefined;
  }

  function getProductPrice() {
    var form = getProductFormForBar();
    var atcEl = form ? form.querySelector('[data-atc-price]') : document.querySelector('[data-atc-price]');
    if (atcEl && form) {
      var planId = ruggedDogProductFormSellingPlanId(form);
      if (planId) {
        var cents = getBarSellingPlanPrice(form, planId);
        if (cents !== undefined) return cents;
      }
      return parseInt(atcEl.getAttribute('data-unit-price'), 10) || 0;
    }
    return parseInt(bar.getAttribute('data-product-price'), 10) || 0;
  }

  function getQty() {
    var input = document.querySelector('.product-info__inline-qty input[name="quantity"]');
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function getAddonsTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      total += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
    });
    return total;
  }

  function hasUncheckedAddons() {
    return document.querySelectorAll('.product-addons__checkbox:not(:checked)').length > 0;
  }

  function update() {
    if (!fillEl || !textEl) return;

    if (hasFreeShippingTag) {
      fillEl.style.width = '100%';
      textEl.innerHTML = successMsg;
      bar.classList.add('shipping-bar--complete');
      if (hintEl) hintEl.hidden = true;
      bar.style.display = '';
      return;
    }

    var projected = cartTotal + (getProductPrice() * getQty()) + getAddonsTotal();
    var pct = Math.min((projected / threshold) * 100, 100);
    var remaining = threshold - projected;

    fillEl.style.width = pct + '%';

    if (remaining <= 0) {
      textEl.innerHTML = successMsg;
      bar.classList.add('shipping-bar--complete');
      if (hintEl) hintEl.hidden = true;
    } else {
      var formatted = fmt.format(remaining / 100);
      textEl.innerHTML = msgTemplate.replace('{amount}', '<strong>' + formatted + '</strong>');
      bar.classList.remove('shipping-bar--complete');
      if (hintEl && hintMsg) {
        hintEl.textContent = hintMsg;
        hintEl.hidden = !hasUncheckedAddons();
      }
    }

    bar.style.display = '';
  }

  function refreshCartAndUpdate() {
    fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price || 0;
        update();
      })
      .catch(function () { update(); });
  }

  refreshCartAndUpdate();

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="quantity"]') ||
      e.target.matches('.product-addons__checkbox') ||
      e.target.matches('input[name="selling_plan"]') ||
      e.target.matches('select[name="selling_plan"]')
    ) {
      update();
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"]')) update();
  });

  document.addEventListener('variant:change', function () {
    requestAnimationFrame(update);
  });

  document.addEventListener('foxsell:change', function () {
    update();
  })

  document.documentElement.addEventListener('cart:change', function (e) {
    cartTotal = (e.detail && e.detail.cart) ? e.detail.cart.total_price || 0 : cartTotal;
    update();
  });
  
  document.addEventListener('cart:refresh', refreshCartAndUpdate);
  document.addEventListener('cart:external-change', function (e) {
    cartTotal = (e.detail && e.detail.cart) ? e.detail.cart.total_price || 0 : cartTotal;
    update();
  });
})();

/* ── Pack cards: show subscription price when a selling plan is active ── */
(function () {
  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getSellingPlanId() {
    var form = document.querySelector('form[is="product-form"]');
    if (!form) return '';
    var el = form.querySelector('input[name="selling_plan"]');
    return el ? String(el.value || '').trim() : '';
  }

  function updateCards() {
    var cards = document.querySelectorAll('label.pack-option-card[data-variant-base-price]');
    if (!cards.length) return;
    var planId = getSellingPlanId();
    cards.forEach(function (card) {
      var base = parseInt(card.getAttribute('data-variant-base-price'), 10) || 0;
      var divisor = parseInt(card.getAttribute('data-pack-unit-divisor'), 10) || 1;
      var suffix = card.getAttribute('data-unit-suffix') || '';
      var cents = base;

      if (planId) {
        try {
          var map = JSON.parse(card.getAttribute('data-selling-plan-prices'));
          if (map[planId] != null) cents = parseInt(map[planId], 10);
        } catch (e) {}
      }

      var totalEl = card.querySelector('.pack-option-card__total');
      var unitEl = card.querySelector('.pack-option-card__unit');
      if (totalEl) totalEl.textContent = fmt.format(cents / 100);
      if (unitEl) unitEl.textContent = fmt.format(Math.floor(cents / divisor) / 100) + suffix;
    });
  }

  var lastPlanId = '';
  function checkAndUpdate() {
    var current = getSellingPlanId();
    if (current !== lastPlanId) {
      lastPlanId = current;
      updateCards();
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="selling_plan"]')) {
      lastPlanId = getSellingPlanId();
      updateCards();
    }
  });
  document.addEventListener('variant:change', function () {
    setTimeout(updateCards, 50);
    setTimeout(updateCards, 300);
  });

  var rcWidget = document.querySelector('recharge-subscription-widget, .recharge-subscription-widget');
  if (rcWidget) {
    rcWidget.addEventListener('click', function () {
      setTimeout(checkAndUpdate, 150);
    });
  }

  updateCards();
  lastPlanId = getSellingPlanId();
  setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 500);
  setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 1500);
  window.addEventListener('load', function () {
    setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 300);
  });
})();

/* ── Mobile sticky ATC: show on land, hide while main ATC is on screen,
      show again after scrolling past it. Desktop is left to the theme. ── */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 699px)');
  var PASS_OFFSET = 140; // px above viewport top before sticky reappears
  var APPROACH_OFFSET = 64; // px below viewport bottom to start hiding
  var nativeToggle = DOMTokenList.prototype.toggle;

  function getMainAtcZone() {
    return document.querySelector('.product-info__qty-atc-row');
  }

  function isFooterVisible() {
    var footer = document.querySelector('.shopify-section--footer, .footer');
    return !!footer && footer.getBoundingClientRect().top < window.innerHeight;
  }

  function updateSticky(sticky) {
    if (!sticky || !MOBILE_MQ.matches) return;

    var zone = getMainAtcZone();
    if (!zone) return;

    var rect = zone.getBoundingClientRect();
    var atcInRange = rect.bottom > PASS_OFFSET && rect.top < window.innerHeight + APPROACH_OFFSET;
    var show = !atcInRange && !isFooterVisible();
    if (show) DOMTokenList.prototype.add.call(sticky.classList, 'is-visible');
    else DOMTokenList.prototype.remove.call(sticky.classList, 'is-visible');
  }

  function updateAll() {
    if (!MOBILE_MQ.matches) return;
    document.querySelectorAll('product-quick-add').forEach(updateSticky);
  }

  var ticking = false;
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateAll();
    });
  }

  function setup(el) {
    if (!el || el.dataset.ruggedStickyAtc === '1') return;
    el.dataset.ruggedStickyAtc = '1';

    // Theme's own observer tries to show/hide the bar too. On mobile, ignore
    // its toggle and re-sync from our scroll logic instead.
    el.classList.toggle = function (token, force) {
      if (token === 'is-visible' && MOBILE_MQ.matches) {
        updateSticky(el);
        return this.contains(token);
      }
      return nativeToggle.call(this, token, force);
    };

    updateSticky(el);
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('variant:change', function () {
    setTimeout(updateAll, 50);
    setTimeout(updateAll, 300);
  });

  function initAll() {
    document.querySelectorAll('product-quick-add').forEach(setup);
    updateAll();
  }

  initAll();

  // product-rerender can replace the sticky bar on variant change
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('product-quick-add')) setup(node);
        else if (node.querySelectorAll) node.querySelectorAll('product-quick-add').forEach(setup);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
